import { createUseStyles } from 'react-jss';
import { Dialog, styled, Theme } from '@mui/material';
import { ITheme } from '../../theme';

export const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
  '& label.Mui-focused': {
    color: 'black',
  },
}));

export const inputRowStyles = {
  display: 'flex',
  justifyContent: 'space-between',
  gap: 5,
};

export const dialogStyles = { m: 0, p: 2 };

export const boxStyles = { width: 800, maxWidth: '100%' };

export const iconButtonStyles = {
  position: 'absolute',
  right: 8,
  top: 8,
  color: (theme: Theme): string => theme.palette.grey[500],
};

type RuleNames =
  | 'uploadBtn'
  | 'modalHeader'
  | 'modal'
  | 'uploadText'
  | 'uploadBlock'
  | 'modalTitle'
  | 'modalMainTitle'
  | 'modalInp'
  | 'modalContactInp'
  | 'inpBlock'
  | 'checkboxBlock'
  | 'errorText'
  | 'cancelBtn'
  | 'modalSecondTitle'
  | 'inputStyle'
  | 'dragBlock'
  | 'croppedImage'
  | 'imgActions'
  | 'linksBox'
  | 'addBlock'
  | 'linksTitle'
  | 'link'
  | 'deleteIcon'
  | 'addLink'
  | 'linksBlock'
  | 'errors'
  | 'emailErrors'
  | 'selectErrors'
  | 'volunteerAvatar'
  | 'contactErrors';

const PREFIX = 'ModalVolunteerDetails';
export const useStyles = createUseStyles<RuleNames, unknown, ITheme>(
  (theme: ITheme) => (
    {
      fontFamily: theme.sfPro,
      modal: {
        '& .MuiOutlinedInput-root': {
          fontSize: 14,
          fontFamily: theme.sfPro,
          '&.Mui-focused': {
            '& .MuiOutlinedInput-notchedOutline': {
              border: '1px solid black',
            },
          },
        },
        '& .MuiPaper-root': {
          borderRadius: '20px',
        },
        '& .MuiDialogContent-root': {
          padding: '0 40px 40px 40px',
        },
        '& .MuiDialogTitle-root': {
          padding: '40px 40px 20px 40px',
        },
        '& .MuiDialogActions-root': {
          padding: '10px 40px 60px',
        },
        '& .MuiSvgIcon-root': {
          width: '1em',
          height: '1em',
        },
        '& .MuiIconButton-root': {
          margin: '35px 25px',
        },
        '& .MuiFormLabel-root': {
          color: '#999999',
        },
        '& .MuiInputLabel-shrink': {
          color: theme.darkGreen,
        },
      },
      uploadBtn: {
        backgroundColor: theme.black,
      },
      modalHeader: {
        display: 'flex',
        alignItems: 'center',
      },
      uploadText: {
        color: 'rgba(0, 0, 0, 0.5)',
        marginTop: '8px',
      },
      uploadBlock: {
        marginLeft: '28px',
      },
      modalTitle: {
        color: theme.black,
        fontSize: '20px',
        margin: '20px 0',
      },
      modalMainTitle: {
        fontFamily: theme.caslonDoric,
        fontSize: '36px',
        fontWeight: 600,
      },
      modalInp: {
        marginTop: '28px',
        maxWidth: '800px',
      },
      modalContactInp: {
        marginTop: '28px',
      },
      inpBlock: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
      },
      checkboxBlock: {
        display: 'flex',
        justifyContent: 'space-between',
      },
      errorText: {
        marginTop: -55,
        position: 'absolute',
        width: 220,
      },
      cancelBtn: {
        color: theme.black,
        background: theme.white,
        border: '1px solid black',
      },
      modalSecondTitle: {
        color: theme.black,
        fontSize: '20px',
        margin: '40px 0 20px',
      },
      inputStyle: {
        cursor: 'pointer',
        position: 'absolute',
        top: '0',
        bottom: '0',
        left: '0',
        right: '0',
        opacity: '0',
        width: '28px',
        zIndex: '-111',
      },
      dragBlock: {
        position: 'relative',
      },
      croppedImage: {
        clipPath: 'circle(50% at center)',
        width: 100,
        height: 100,
        objectFit: 'cover',
      },
      imgActions: {
        display: 'flex',
        width: 220,
        justifyContent: 'space-between',
      },
      linksBox: {
        display: 'flex',
        gap: 30,
        flexDirection: 'column',
        justifyContent: 'space-between',
      },
      linksTitle: {
        color: theme.black,
        fontSize: '20px',
        margin: '20px 0',
        fontWeight: 600,
      },
      linksBlock: {
        display: 'flex',
        alignContent: 'baseline',
        marginBottom: 5,
      },
      link: {
        marginRight: 10,
        fontWeight: 600,
      },
      addLink: {
        color: 'rgba(0, 0, 0, 0.5)',
      },
      deleteIcon: {
        cursor: 'pointer',
      },
      addBlock: {
        cursor: 'pointer',
        display: 'flex',
        width: 125,
        justifyContent: 'space-between',
      },
      errors: {
        marginTop: -57,
        position: 'absolute',
        width: 400,
      },
      emailErrors: {
        marginTop: 27,
        position: 'absolute',
        width: 400,
      },
      selectErrors: {
        position: 'absolute',
        width: 400,
      },
      contactErrors: {
        marginTop: 27,
        position: 'absolute',
        width: 400,
      },
      volunteerAvatar: {
        width: '100px !important',
        height: '100px !important',
        borderRadius: '50% !important',
        fontSize: '20px !important',
        objectFit: 'cover',
      },
    }
  ),
  { name: PREFIX },
);
